import store from "../../store";

export default async (to, from, next) => {
  if (store.getters.isAuthenticated === false) {
    await store.dispatch("loginFromCookie");
  }

  // Validate the restored token once on first load (App.vue shows a loader).
  if (store.getters.isSessionResolved === false) {
    await store.dispatch("validateSession");
  }

  if (to.meta.public) {
    return next();
  }

  if (store.getters.isAuthenticated === false) {
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  next();
};
